export const ItemTypes = {
  RECIPE: "recipe"
}